import { get } from "../xhr"


export function getAdminData () {
    return get(`admin/dash-data`, 'application/json')
}